import { ChevronLeft } from '@cmp-src/icons/TacticIcons/ChevronLeft';
import { ChevronRight } from '@cmp-src/icons/TacticIcons/ChevronRight';
import { ButtonProps } from '@v2/components/ui/button';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup';
import { ButtonInGroup } from '../ButtonGroup/ButtonInGroup';
import { cn } from '@gettactic/helpers';

export interface ArrowsGroupProps {
  rightProps?: ButtonProps;
  leftProps?: ButtonProps;
  className?: string;
  showLeft?: boolean;
  showRight?: boolean;
}

export const ArrowsGroup = ({
  rightProps,
  leftProps,
  className,
  showLeft = true,
  showRight = true
}: ArrowsGroupProps) => {
  if (!showLeft && !showRight) return null;
  return (
    <ButtonGroup className={cn(className)}>
      {showLeft && (
        <ButtonInGroup
          {...leftProps}
          className={cn('w-[38px]', leftProps?.className)}
          isAlone={!showRight}
        >
          <ChevronLeft className="h-4 w-4" />
        </ButtonInGroup>
      )}
      {showRight && (
        <ButtonInGroup
          {...rightProps}
          className={cn('w-[38px]', rightProps?.className)}
        >
          <ChevronRight className="h-4 w-4" />
        </ButtonInGroup>
      )}
    </ButtonGroup>
  );
};
